// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__m6lHU"};